
export function SessionStateError (response) {
  this.response = response;
}

